import { FaShieldAlt, FaClock, FaHandshake, FaChartLine, FaHeadset, FaBrain, FaRocket, FaCheck } from 'react-icons/fa';

const WhyChooseUs = () => {
  const features = [
    {
      icon: FaRocket,
      title: 'First Growing Process',
      description: 'Bring to the table win-win survival strategies to ensur.'
    },
    {
      icon: FaHeadset,
      title: 'Dedicated Support 24/7',
      description: 'Leverage agile frameworks to provide a robust.'
    },
    {
      icon: FaBrain,
      title: 'AI Machine & Deep Learning',
      description: 'Podcasting operational change management inside.'
    }
  ];

  return (
    <section className="section-padding bg-white relative font-opensans overflow-hidden">
       {/* Background Elements */}
       <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
            <div className="absolute top-20 left-10 w-64 h-64 bg-gray-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
            <div className="absolute top-20 right-10 w-64 h-64 bg-gray-200 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
       </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Column - Image/Illustration */}
            <div className="relative">
                <div className="relative rounded-[40px] overflow-hidden shadow-2xl border-4 border-white bg-white">
                    <img 
                        src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800" 
                        alt="Why Choose Us" 
                        className="w-full h-full object-cover  hover:grayscale-0 transition-all duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent"></div>
                    
                    {/* Floating Growth Chart Card */}
                    <div className="absolute bottom-10 right-10 bg-gradient-to-r from-[#22446b] to-[#338edc] p-6 rounded-2xl shadow-xl animate-float border border-transparent">
                        <div className="flex items-center gap-4 mb-2">
                            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center text-white">
                                <FaChartLine />
                            </div>
                            <div>
                                <p className="text-xs text-white/90 font-bold uppercase">Growth</p>
                                <p className="text-xl font-bold font-rajdhani text-white">+150%</p>
                            </div>
                        </div>
                        <div className="w-32 h-2 bg-white/20 rounded-full overflow-hidden">
                            <div className="h-full bg-white w-[75%]"></div>
                        </div>
                    </div>
                </div>
                {/* Decorative Shape */}
                <div className="absolute -z-10 top-10 -left-10 w-full h-full border-2 border-gray-200 rounded-[40px] "></div>
            </div>

            {/* Right Column - Content */}
            <div>
                 <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-[#22446b] to-[#338edc] border border-transparent rounded-full text-white text-sm font-bold uppercase tracking-wider mb-6">
                    <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
                    Why Choose Us
                </div>
                <h2 className="text-4xl lg:text-5xl font-rajdhani font-bold text-[#22446b] mb-6 leading-tight">
                    The world's best companies trust <span className="text-transparent bg-clip-text bg-[#22446b]">tekone solutions</span>
                </h2>
                <p className="text-lg text-gray-600 mb-10 leading-relaxed font-opensans">
                    Bring to the table win-win survival strategies to ensure proactive domination At the end of the day.
                </p>

                <div className="space-y-8">
                    {features.map((feature, index) => (
                        <div key={index} className="flex gap-5 group">
                            <div className="w-16 h-16 rounded-xl bg-white shadow-lg border border-gray-50 flex items-center justify-center flex-shrink-0 group-hover:bg-[#338edc] transition-all duration-300 group-hover:-translate-y-1">
                                <feature.icon className="text-2xl text-[#22446b] group-hover:text-white transition-colors" />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold font-rajdhani text-[#22446b] mb-2 group-hover:text-gray-700 transition-colors">
                                    {feature.title}
                                </h3>
                                <p className="text-gray-600 leading-relaxed text-sm">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;